const subscribeProductKeys = {
    finApi: 'finapi',
    individualAsset: 'ia',
    finAgent: 'finagent',
    finAgentAdmin: 'finagent-admin'
}

const subscriptionPlans = {
    advanced: 'advanced',
    ai: 'ai',
}

export default {
    subscribeProductKeys,
    subscriptionPlans
}